import { render, staticRenderFns } from "./ColorGap.vue?vue&type=template&id=e4902328&scoped=true&"
import script from "./ColorGap.vue?vue&type=script&lang=js&"
export * from "./ColorGap.vue?vue&type=script&lang=js&"
import style0 from "./ColorGap.vue?vue&type=style&index=0&id=e4902328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4902328",
  null
  
)

export default component.exports